import Vue from 'vue'
import Router from 'vue-router'
import { isLoggedIn } from './utils/auth'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/payment'
    },
    {
      path: '/auth',
      name: 'auth',
      component: () => import('./views/Auth.vue'),
      meta: { public: true }  // 公开页面，不需要认证
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('./views/Login.vue'),
      meta: { public: true }
    },
    {
      path: '/share-center',
      name: 'ShareCenter',
      component: () => import('./views/ShareCenter.vue'),
      meta: { hideTabbar: true }
    },
    {
      path: '/finance-logs',
      name: 'FinanceLogs',
      component: () => import('./views/FinanceLogs.vue'),
      meta: { hideTabbar: true }
    },
    {
      path: '/withdraw-logs',
      name: 'WithdrawLogs',
      component: () => import('./views/WithdrawLogs.vue'),
      meta: { hideTabbar: true }
    },
    {
      path: '/payment',
      name: 'payment',
      component: () => import('./views/Payment.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/detail_payment',
      name: 'detail_payment',
      component: () => import('./views/DetailPayment.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/mine',
      name: 'mine',
      component: () => import('./views/SaasProfile.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/brand_detail',
      name: 'brand_detail',
      component: () => import('./views/BrandDetail.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/order',
      name: 'order',
      component: () => import('./views/Order.vue'),
      meta: { requiresAuth: true, hideTabbar: true }
    },
    {
      path: '/order-pay',
      name: 'order_pay',
      component: () => import('./views/OrderPay.vue'),
      meta: { requiresAuth: true, hideTabbar: true }
    },
    {
      path: '/my-orders',
      name: 'my_orders',
      component: () => import('./views/MyOrders.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/order-detail',
      name: 'order_detail',
      component: () => import('./views/OrderDetail.vue'),
      meta: { requiresAuth: true, hideTabbar: true }
    }
  ]
})

// 全局路由守卫 - 检查认证状态
router.beforeEach((to, from, next) => {
  // 如果页面标记为公开，直接放行
  if (to.meta && to.meta.public) {
    next()
    return
  }

  // 如果页面需要认证
  if (to.meta && to.meta.requiresAuth) {
    // 检查是否已登录
    if (!isLoggedIn()) {
      // 未登录，跳转到认证页，并记录原目标页面
      next({
        path: '/auth',
        query: { redirect: to.fullPath }
      })
      return
    }
  }

  // 默认放行
  next()
})

export default router
